import React from 'react'
import { Helmet } from 'react-helmet-async'
import { UsefulResourcesLayout } from '../../layouts/Support'

const UsefulResourcesPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Useful resources</title>
      <meta name="description" content="Useful resources page" />
    </Helmet>

    <UsefulResourcesLayout />
  </React.Fragment>
)

export default UsefulResourcesPage
